import { createSelector } from "reselect";

const selectState = (state) => state.general;

export const selectBrands = createSelector(
  [selectState],
  (general) => general.brands
);

export const selectCategories = createSelector(
  [selectState],
  (general) => general.categories
);

export const selectGroups = createSelector(
  [selectState],
  (general) => general.groups
);

export const selectSuppliers = createSelector(
  [selectState],
  (general) => general.suppliers
);

export const selectCustomers = createSelector(
  [selectState],
  (general) => general.customers
);

export const selectCurrencies = createSelector(
  [selectState],
  (general) => general.currencies
);
